import slugify from 'slugify';
import getClassifiedsSite from 'utils/getClassifiedsSite';
// import * as R from 'ramda';

const allowIndexing = process.env.DISABLE_INDEXING === 'true';
const disableIndexingAndFollowLinks = 'noindex,nofollow';
const enableIndexingAndFollowLinks = 'index,follow';

const getRobots = rule =>
  allowIndexing ? disableIndexingAndFollowLinks : rule;

const home = _ => {
  const results = {
    whatcar: {
      title: 'Used cars for sale on What Car?',
      description:
        'Looking for used cars? Find your ideal second hand used car from top dealers in your area on What Car? Classifieds.',
      url: '/used-cars/',
      robots: getRobots(enableIndexingAndFollowLinks)
    },
    autocar: {
      title: 'Used cars for sale on Autocar',
      description:
        'Looking for a used car? Find your ideal second hand used car from approved used dealers in your area on Autocar Classifieds.',
      url: '/used-cars/',
      robots: getRobots(enableIndexingAndFollowLinks)
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[classifiedsSite];
};

// const isFiltered = filter => {
//   const props = ['make', 'model', 'nearlynew', 'used', 'isPostCodeValid'];
//   return R.keys(filter).filter(_ => !R.contains(_, props)).length > 0;
// };

const resultsCar = (props, count, filter, pagination) => {
  pagination = pagination || {};
  filter = filter || {};
  const make = props.make ? slugify(props.make) : '';
  const makeText = props.make ? props.make : '';
  const model = props.model ? slugify(props.model) : '';
  const modelText = props.model ? ' ' + props.model : '';
  const title = props.make ? `${props.make}${modelText} cars` : 'cars';
  const descriptionTitle = props.make ? `${props.make}${modelText} car` : 'car';
  const modelUrl = model ? `/${model}` : '';
  const url = make ? `${make}${modelUrl}` : 'all';
  const robots =
    url === 'all'
      ? disableIndexingAndFollowLinks
      : enableIndexingAndFollowLinks;

  const results = {
    whatcar: {
      title: `Used ${title} for sale on What Car?`,
      description: `Find and buy your perfect used ${descriptionTitle} with What Car? Classifieds, the easiest and most powerful used car search around.`,
      url: `/used-cars/${url.toLowerCase()}`,
      robots: getRobots(robots),
      blurb: `What Car? Classifieds have ${count} approved used ${title} available for sale from ${makeText} approved dealers. Browse our classifieds now, the easiest and most powerful used car search around and find the perfect approved used ${title} near you.`,
      pagination: pagination
    },
    autocar: {
      title: `Used ${title} for sale on Autocar`,
      description: `Search for your perfect used ${descriptionTitle} with Autocar Classifieds. Every car comes with a warranty & is guaranteed to be less than eight years & 100,000 miles old.`,
      url: `/used-cars/${url.toLowerCase()}`,
      robots: getRobots(robots),
      blurb: `Autocar Classifieds has ${count} approved used ${title}  available for sale from ${makeText} approved dealers. Browse our classifieds now to find the perfect approved used ${title} near you using the easiest and most powerful used car search around.`,
      pagination: pagination
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[classifiedsSite];
};

const resultsDealer = (dealer, id, pagination) => {
  pagination = pagination || {};

  const results = {
    whatcar: {
      title: `${dealer} used cars for sale on What Car?`,
      description: `Find and buy your perfect used car from ${dealer} on What Car? Classifieds, the easiest and most powerful used car search around.`,
      url: `/used-cars/dealer/${id}`,
      robots: getRobots(enableIndexingAndFollowLinks),
      blurb: `Find and buy your perfect used car from ${dealer} on What Car? Classifieds, the easiest and most powerful used car search around.`,
      pagination: pagination
    },
    autocar: {
      title: `${dealer} used cars for sale on Autocar`,
      description: `Find and buy your perfect used car from ${dealer} on Autocar Classifieds, the easiest and most powerful used car search around.`,
      url: `/used-cars/dealer/${id}`,
      robots: getRobots(enableIndexingAndFollowLinks),
      blurb: `Find and buy your perfect used car from ${dealer} on Autocar Classifieds, the easiest and most powerful used car search around.`,
      pagination: pagination
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[classifiedsSite];
};

const resultsBodyStyle = (category, count, pagination) => {
  pagination = pagination || {};

  const results = {
    whatcar: {
      title: `Used ${category} cars for sale on What Car?`,
      description: `Find and buy your perfect used ${category} with What Car? Classifieds, the easiest and most powerful used car search around.`,
      url: `/used-cars/${category}`,
      robots: getRobots(enableIndexingAndFollowLinks),
      blurb: `What Car? Classifieds have ${count} approved used ${category} available for sale from approved dealers. Browse our classifieds now, the easiest and most powerful used car search around and find the perfect approved used ${category} near you.`,
      pagination: pagination
    },
    autocar: {
      title: `Used ${category} cars for sale on Autocar`,
      description: `Search for your perfect used ${category} on Autocar Classifieds. Every car comes with a warranty & is guaranteed to be less than eight years & 100,000 miles old.`,
      url: `/used-cars/${category}`,
      robots: getRobots(enableIndexingAndFollowLinks),
      blurb: `Autocar Classified have ${count} approved used ${category} available for sale from approved dealers. Browse our classifieds now, the easiest and most powerful used car search around and find the perfect approved used ${category} near you.`,
      pagination: pagination
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[classifiedsSite];
};

const listing = (title, county, url, image) => {
  const results = {
    whatcar: {
      title: title
        ? `Used ${title} car for sale on What Car?`
        : `Used car for sale on What Car?`,
      description: `Used ${title} for sale in ${county} with What Car? Classifieds, the easiest and most powerful used car search around.`,
      url: url,
      robots: getRobots(disableIndexingAndFollowLinks),
      image: image
    },
    autocar: {
      title: title
        ? `Used ${title} car for sale on Autocar`
        : `Used car for sale on Autocar`,
      description: `Used ${title} for sale in ${county} with Autocar Classifieds. Every car comes with a warranty & is guaranteed to be less than eight years & 100,000 miles old.`,
      url: url,
      robots: getRobots(disableIndexingAndFollowLinks),
      image: image
    }
  };

  const classifiedsSite = getClassifiedsSite();
  return results[classifiedsSite];
};

module.exports = { home, resultsCar, resultsDealer, resultsBodyStyle, listing };



// WEBPACK FOOTER //
// ./src/App/variables/seo.js